//接口统一管理
import http from '@/request/http'

//用户通知列表
export const getMsgListByuserId = params => http.fetchPost( process.env.BASE_URL+'/api/notify-new-user/getMsgListByuserId', params);
//获取系统通知类型列表
export const getNoticeTypeList = params => http.fetchPost( process.env.BASE_URL+'/api/notify-new-type/getList', params);
//用户未读通知数量
export const getUnreadMsg = params => http.fetchPost( process.env.BASE_URL+'/api/notify-new-user/getUnreadMsg', params);
//更新用户指定通知状态为已读
export const updateMsgRead = params => http.fetchPost( process.env.BASE_URL+'/api/notify-new-user/updateMsgRead', params);
//更新用户所有通知状态为已读
export const updateMsgReadAll = params => http.fetchPost( process.env.BASE_URL+'/api/notify-new-user/updateAllMsgRead', params);
//获取文章列表
export const articleList = params => http.fetchPost( process.env.BASE_URL+'/api/article/list', params);
//文章详情
export const articleInfo = params => http.fetchPost( process.env.BASE_URL+'/api/article/info', params);
//搜索
export const searchList = params => http.fetchPost( process.env.BASE_URL+'/api/search/list', params);
//搜索热搜词
export const searchHot = params => http.fetchPost( process.env.BASE_URL+'/api/search/hot', params);
//我的课程
export const courseInquiryList = params => http.fetchPost( process.env.BASE_URL+'/api/UserCourses/coursesGet', params);
//课程列表
export const courseInquiryList1 = params => http.fetchPost( process.env.BASE_URL+'/api/courses/courseInquiry', params);
//课程新增
export const coursesSet = params => http.fetchPost( process.env.BASE_URL+'/api/UserCourses/coursesSet', params);
//课程删除
export const coursesDelete = params => http.fetchPost( process.env.BASE_URL+'/api/UserCourses/coursesDelete', params);
//课程详情
export const courseDetails = params => http.fetchPost( process.env.BASE_URL+'/api/courses/courseDetails', params);
//根据推荐位模块查询产品
export const productByModule = params => http.fetchPost( process.env.BASE_URL+'/api/product/getByModule', params);
//获取首页我的应用
export const getAppListHome = params => http.fetchPost( process.env.BASE_URL+'/api/user/getAppList', params);
//保存我的应用
export const saveAppListHome = params => http.fetchPost( process.env.BASE_URL+'/api/user/saveAppList', params);

// 收藏
export const collect = params => http.fetchPost(process.env.BASE_URL + '/api/userCollect/add', params);
// 取消收藏
export const cancelCollect = params => http.fetchPost(process.env.BASE_URL + '/api/userCollect/deleteOne', params);
// 获取收藏状态
export const getCollectStatus = params => http.fetchPost(process.env.BASE_URL + '/api/userCollect/collectStatus', params);
//区域联动
export const areaTree = params => http.fetchPost(process.env.BASE_URL + '/api/area/tree', params);
//预约列表/维保记录
export const afterServiceList = params => http.fetchPost(process.env.BASE_URL + '/api/afterService/list', params);
export const afterServiceInsert = params => http.fetchPost(process.env.BASE_URL + '/api/afterService/insert', params);
//商务净水机，根据userId获取角色类型
export const getUserRole = params => http.fetchPost(process.env.BASE_URL + '/api/user/list/userRole', params);



// WEBPACK FOOTER //
// ./src/request/home.js